import { muiColorsOverrideHandler } from "./muiColorsOverrideHandler";

export const muiThemeOverrideHandler = muiColorsOverrideHandler;
